/**
 * Note this was taken from https://github.com/drykovanov/mapbox-gl-draw-rotate-scale-rect-mode
 *
 * MIT License
 * Copyright (c) 2019 drykovanov
 *
 * The repo does not work out of the box and required minor modification.
 */

/* eslint-disable */
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '@map... Remove this comment to see the full error message
import * as Constants from '@mapbox/mapbox-gl-draw/src/constants';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '@map... Remove this comment to see the full error message
import * as CommonSelectors from '@mapbox/mapbox-gl-draw/src/lib/common_selectors';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '@map... Remove this comment to see the full error message
import createSupplementaryPoints from '@mapbox/mapbox-gl-draw/src/lib/create_supplementary_points';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '@map... Remove this comment to see the full error message
import doubleClickZoom from '@mapbox/mapbox-gl-draw/src/lib/double_click_zoom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '@map... Remove this comment to see the full error message
import moveFeatures from '@mapbox/mapbox-gl-draw/src/lib/move_features';
import bearing from '@turf/bearing';
import center from '@turf/center';
import destination from '@turf/destination';
import distance from '@turf/distance';
import { lineString, point } from '@turf/helpers';
import midpoint from '@turf/midpoint';
import transformRotate from '@turf/transform-rotate';
import transformScale from '@turf/transform-scale';

export const TxRectMode = {};

export const TxCenter = {
  Center: 0, // rotate or scale around center of polygon
  Opposite: 1, // rotate or scale around opposite side of polygon
};

function parseTxCenter(value: any, defaultTxCenter = TxCenter.Center) {
  if (value === undefined || value === null) {
    return defaultTxCenter;
  }

  if (value === TxCenter.Center || value === TxCenter.Opposite) {
    return value;
  }

  if (value === 'center') {
    return TxCenter.Center;
  }

  if (value === 'opposite') {
    return TxCenter.Opposite;
  }

  throw Error(`Invalid TxCenter: ${value}`);
}

/*
    opts = {
        featureId: ...,

        canScale: default true,
        canRotate: default true,

        rotatePivot: default 'center' or 'opposite',
        scaleCenter: default 'center' or 'opposite',

        canSelectFeatures: default true,    // can exit to simple_select mode
    }
 */
(TxRectMode as any).onSetup = function (opts: any) {
  const featureId =
    opts.featureIds &&
    Array.isArray(opts.featureIds) &&
    opts.featureIds.length > 0
      ? opts.featureIds[0]
      : opts.featureId;

  const feature = this.getFeature(featureId);

  if (!feature) {
    throw new Error('You must provide a valid featureId to enter tx_poly mode');
  }

  if (feature.type !== Constants.geojsonTypes.POLYGON) {
    throw new TypeError('tx_poly mode can only handle polygons');
  }
  if (
    feature.coordinates === undefined ||
    feature.coordinates.length !== 1 ||
    feature.coordinates[0].length <= 2
  ) {
    throw new TypeError('tx_poly mode can only handle polygons');
  }

  const state = {
    featureId,
    feature,

    canTrash: opts.canTrash !== undefined ? opts.canTrash : true,

    canScale: opts.canScale !== undefined ? opts.canScale : true,
    canRotate: opts.canRotate !== undefined ? opts.canRotate : true,

    singleRotationPoint:
      opts.singleRotationPoint !== undefined ? opts.singleRotationPoint : false,
    rotationPointRadius:
      opts.rotationPointRadius !== undefined ? opts.rotationPointRadius : 1.0,

    rotatePivot: parseTxCenter(opts.rotatePivot, TxCenter.Center),
    scaleCenter: parseTxCenter(opts.scaleCenter, TxCenter.Center),

    canSelectFeatures:
      opts.canSelectFeatures !== undefined ? opts.canSelectFeatures : true,
    // selectedFeatureMode: opts.selectedFeatureMode != undefined ? opts.selectedFeatureMode : 'simple_select',

    dragMoveLocation: opts.startPos || null,
    dragMoving: false,
    canDragMove: false,
    selectedCoordPaths: opts.coordPath ? [opts.coordPath] : [],
  };

  if (!(state.canRotate || state.canScale)) {
    console.warn('Non of canScale or canRotate is true');
  }

  this.setSelectedCoordinates(
    this.pathsToCoordinates(featureId, state.selectedCoordPaths)
  );
  this.setSelected(featureId);
  doubleClickZoom.disable(this);

  this.setActionableState({
    combineFeatures: false,
    uncombineFeatures: false,
    trash: state.canTrash,
  });

  return state;
};

(TxRectMode as any).toDisplayFeatures = function (
  state: any,
  geojson: any,
  push: any
) {
  if (state.featureId === geojson.properties.id) {
    geojson.properties.active = Constants.activeStates.ACTIVE;
    push(geojson);

    const suppPoints = createSupplementaryPoints(geojson, {
      map: this.map,
      midpoints: false,
      selectedPaths: state.selectedCoordPaths,
    });

    if (state.canScale) {
      this.computeBisectrix(suppPoints);
      suppPoints.forEach(push);
    }

    if (state.canRotate) {
      const rotPoints = this.createRotationPoints(state, geojson, suppPoints);
      rotPoints.forEach(push);
    }
  } else {
    geojson.properties.active = Constants.activeStates.INACTIVE;
    push(geojson);
  }

  // this.fireActionable(state);
  this.setActionableState({
    combineFeatures: false,
    uncombineFeatures: false,
    trash: state.canTrash,
  });

  // this.fireUpdate();
};

(TxRectMode as any).onStop = function () {
  doubleClickZoom.enable(this);
  this.clearSelectedCoordinates();
};

// TODO why I need this?
(TxRectMode as any).pathsToCoordinates = function (featureId: any, paths: any) {
  return paths.map((coord_path: any) => {
    return { feature_id: featureId, coord_path };
  });
};

(TxRectMode as any).computeBisectrix = function (points: any) {
  for (let i1 = 0; i1 < points.length; i1++) {
    const i0 = (i1 - 1 + points.length) % points.length;
    const i2 = (i1 + 1) % points.length;

    const l1 = lineString([
      points[i0].geometry.coordinates,
      points[i1].geometry.coordinates,
    ]);
    const l2 = lineString([
      points[i1].geometry.coordinates,
      points[i2].geometry.coordinates,
    ]);
    const a1 = bearing(
      points[i0].geometry.coordinates,
      points[i1].geometry.coordinates
    );
    const a2 = bearing(
      points[i2].geometry.coordinates,
      points[i1].geometry.coordinates
    );

    let a = (a1 + a2) / 2.0;

    if (a < 0.0) a += 360;
    if (a > 360) a -= 360;

    points[i1].properties.heading = a;
  }
};

(TxRectMode as any)._createRotationPoint = function (
  rotationWidgets: any,
  featureId: any,
  v1: any,
  v2: any,
  rotCenter: any,
  radiusScale: any
) {
  const cR0 = midpoint(v1, v2).geometry.coordinates;
  const heading = bearing(rotCenter, cR0);
  const distance0 = distance(rotCenter, cR0);
  const distance1 = radiusScale * distance0; // TODO depends on map scale
  const cR1 = destination(rotCenter, distance1, heading, {}).geometry
    .coordinates;

  rotationWidgets.push({
    type: Constants.geojsonTypes.FEATURE,
    properties: {
      meta: Constants.meta.MIDPOINT,
      parent: featureId,
      lng: cR1[0],
      lat: cR1[1],
      coord_path: v1.properties.coord_path,
      heading,
    },
    geometry: {
      type: Constants.geojsonTypes.POINT,
      coordinates: cR1,
    },
  });
};

(TxRectMode as any).createRotationPoints = function (
  state: any,
  geojson: any,
  suppPoints: any
) {
  const { type, coordinates } = geojson.geometry;
  const featureId = geojson.properties && geojson.properties.id;

  const rotationWidgets: any = [];
  if (type != Constants.geojsonTypes.POLYGON) {
    return;
  }

  const corners = suppPoints.slice(0);
  corners[corners.length] = corners[0];

  let v1: any = null;

  const rotCenter = this.computeRotationCenter(state, geojson);

  if (state.singleRotationPoint) {
    this._createRotationPoint(
      rotationWidgets,
      featureId,
      corners[0],
      corners[1],
      rotCenter,
      state.rotationPointRadius
    );
  } else {
    corners.forEach((v2: any) => {
      if (v1 != null) {
        this._createRotationPoint(
          rotationWidgets,
          featureId,
          v1,
          v2,
          rotCenter,
          state.rotationPointRadius
        );
      }

      v1 = v2;
    });
  }

  return rotationWidgets;
};

(TxRectMode as any).startDragging = function (state: any, e: any) {
  this.map.dragPan.disable();
  state.canDragMove = true;
  state.dragMoveLocation = e.lngLat;
};

(TxRectMode as any).stopDragging = function (state: any) {
  this.map.dragPan.enable();
  state.dragMoving = false;
  state.canDragMove = false;
  state.dragMoveLocation = null;
};

const isRotatePoint = CommonSelectors.isOfMetaType(Constants.meta.MIDPOINT);
const isVertex = CommonSelectors.isOfMetaType(Constants.meta.VERTEX);

(TxRectMode as any).onTouchStart = function (state: any, e: any) {
  if (isVertex(e)) return this.onVertex(state, e);
  if (isRotatePoint(e)) return this.onRotatePoint(state, e);
  if (CommonSelectors.isActiveFeature(e)) return this.onFeature(state, e);
  // if (isMidpoint(e)) return this.onMidpoint(state, e);
};

(TxRectMode as any).onMouseDown = function (state: any, e: any) {
  if (isVertex(e)) return this.onVertex(state, e);
  if (isRotatePoint(e)) return this.onRotatePoint(state, e);
  if (CommonSelectors.isActiveFeature(e)) return this.onFeature(state, e);
  // if (isMidpoint(e)) return this.onMidpoint(state, e);
};

const TxMode = {
  Scale: 1,
  Rotate: 2,
};

(TxRectMode as any).onVertex = function (state: any, e: any) {
  // convert internal MapboxDraw feature to valid GeoJSON:
  this.computeAxes(state, state.feature.toGeoJSON());

  this.startDragging(state, e);
  const about = e.featureTarget.properties;
  state.selectedCoordPaths = [about.coord_path];
  state.txMode = TxMode.Scale;
};

(TxRectMode as any).onRotatePoint = function (state: any, e: any) {
  // convert internal MapboxDraw feature to valid GeoJSON:
  this.computeAxes(state, state.feature.toGeoJSON());

  this.startDragging(state, e);
  const about = e.featureTarget.properties;
  state.selectedCoordPaths = [about.coord_path];
  state.txMode = TxMode.Rotate;
};

(TxRectMode as any).onFeature = function (state: any, e: any) {
  state.selectedCoordPaths = [];
  this.startDragging(state, e);
};

(TxRectMode as any).coordinateIndex = function (coordPaths: any) {
  if (coordPaths.length >= 1) {
    const parts = coordPaths[0].split('.');
    return parseInt(parts[parts.length - 1]);
  }
  return 0;
};

(TxRectMode as any).computeRotationCenter = function (
  _state: any,
  polygon: any
) {
  const center0 = center(polygon);
  return center0;
};

(TxRectMode as any).computeAxes = function (state: any, polygon: any) {
  // TODO check min 3 points
  const center0 = this.computeRotationCenter(state, polygon);
  const corners = polygon.geometry.coordinates[0].slice(0);

  const n = corners.length - 1;
  const iHalf = Math.floor(n / 2);

  // var c0 = corners[corners.length - 1];
  // var headings = corners.map((c1) => {
  //     var rotPoint = midpoint(point(c0),point(c1));
  //     var heading = bearing(center0, rotPoint);
  //     c0 = c1;
  //     return heading;
  // });
  // headings = headings.slice(1);

  const rotateCenters = [];
  const headings = [];

  for (let i1 = 0; i1 < n; i1++) {
    let i0 = i1 - 1;
    if (i0 < 0) i0 += n;

    const c0 = corners[i0];
    const c1 = corners[i1];
    const rotPoint = midpoint(point(c0), point(c1));

    let rotCenter = center0;
    if (TxCenter.Opposite === state.rotatePivot) {
      const i3 = (i1 + iHalf) % n; // opposite corner
      var i2 = i3 - 1;
      if (i2 < 0) i2 += n;

      const c2 = corners[i2];
      const c3 = corners[i3];
      rotCenter = midpoint(point(c2), point(c3));
    }

    rotateCenters[i1] = rotCenter.geometry.coordinates;
    headings[i1] = bearing(rotCenter, rotPoint);
  }

  state.rotation = {
    feature0: polygon, // initial feature state
    centers: rotateCenters,
    headings, // rotation start heading for each point
  };

  // compute current distances from centers for scaling

  const scaleCenters = [];
  const distances = [];
  for (let i = 0; i < n; i++) {
    const c1 = corners[i];
    let c0 = center0.geometry.coordinates;
    if (TxCenter.Opposite === state.scaleCenter) {
      var i2 = (i + iHalf) % n; // opposite corner
      c0 = corners[i2];
    }
    scaleCenters[i] = c0;
    distances[i] = distance(point(c0), point(c1), { units: 'meters' });
  }

  // var distances = polygon.geometry.coordinates[0].map((c) =>
  //     turf.distance(center, turf.point(c), { units: 'meters'}) );

  state.scaling = {
    feature0: polygon, // initial feature state
    centers: scaleCenters,
    distances,
  };
};

(TxRectMode as any).onDrag = function (state: any, e: any) {
  if (state.canDragMove !== true) return;
  state.dragMoving = true;
  e.originalEvent.stopPropagation();

  const delta = {
    lng: e.lngLat.lng - state.dragMoveLocation.lng,
    lat: e.lngLat.lat - state.dragMoveLocation.lat,
  };
  if (state.selectedCoordPaths.length > 0 && state.txMode) {
    switch (state.txMode) {
      case TxMode.Rotate:
        this.dragRotatePoint(state, e, delta);
        break;
      case TxMode.Scale:
        this.dragScalePoint(state, e, delta);
        break;
    }
  } else {
    this.dragFeature(state, e, delta);
  }

  state.dragMoveLocation = e.lngLat;
};

(TxRectMode as any).dragRotatePoint = function (
  state: any,
  e: any,
  _delta: any
) {
  if (state.rotation === undefined || state.rotation == null) {
    console.error('state.rotation required');
    return;
  }

  const polygon = state.feature.toGeoJSON();
  const m1 = point([e.lngLat.lng, e.lngLat.lat]);

  const n = state.rotation.centers.length;
  const cIdx = (this.coordinateIndex(state.selectedCoordPaths) + 1) % n;
  // TODO validate cIdx
  const cCenter = state.rotation.centers[cIdx];
  const center = point(cCenter);

  const heading1 = bearing(center, m1);

  const heading0 = state.rotation.headings[cIdx];
  let rotateAngle = heading1 - heading0; // in degrees
  if (CommonSelectors.isShiftDown(e)) {
    rotateAngle = 5.0 * Math.round(rotateAngle / 5.0);
  }

  const rotatedFeature = transformRotate(state.rotation.feature0, rotateAngle, {
    pivot: center,
    mutate: false,
  });

  state.feature.incomingCoords(rotatedFeature.geometry.coordinates);
  // TODO add option for this:
  this.fireUpdate();
};

(TxRectMode as any).dragScalePoint = function (
  state: any,
  e: any,
  _delta: any
) {
  if (state.scaling === undefined || state.scaling == null) {
    console.error('state.scaling required');
    return;
  }

  const polygon = state.feature.toGeoJSON();

  const cIdx = this.coordinateIndex(state.selectedCoordPaths);
  // TODO validate cIdx

  const cCenter = state.scaling.centers[cIdx];
  const center = point(cCenter);
  const m1 = point([e.lngLat.lng, e.lngLat.lat]);

  const dist = distance(center, m1, { units: 'meters' });
  let scale = dist / state.scaling.distances[cIdx];

  if (CommonSelectors.isShiftDown(e)) {
    // TODO discrete scaling
    scale = 0.05 * Math.round(scale / 0.05);
  }

  const scaledFeature = transformScale(state.scaling.feature0, scale, {
    origin: cCenter,
    mutate: false,
  });

  state.feature.incomingCoords(scaledFeature.geometry.coordinates);
  // TODO add option for this:
  this.fireUpdate();
};

(TxRectMode as any).dragFeature = function (state: any, e: any, delta: any) {
  moveFeatures(this.getSelected(), delta);
  state.dragMoveLocation = e.lngLat;
  // TODO add option for this:
  this.fireUpdate();
};

(TxRectMode as any).fireUpdate = function () {
  this.map.fire(Constants.events.UPDATE, {
    action: Constants.updateActions.CHANGE_COORDINATES,
    features: this.getSelected().map((f: any) => f.toGeoJSON()),
  });
};

(TxRectMode as any).onMouseOut = function (state: any) {
  // As soon as you mouse leaves the canvas, update the feature
  if (state.dragMoving) {
    this.fireUpdate();
  }
};

(TxRectMode as any).onTouchEnd = function (state: any) {
  if (state.dragMoving) {
    this.fireUpdate();
  }
  this.stopDragging(state);
};

(TxRectMode as any).onMouseUp = function (state: any) {
  if (state.dragMoving) {
    this.fireUpdate();
  }
  this.stopDragging(state);
};

(TxRectMode as any).clickActiveFeature = function (state: any) {
  state.selectedCoordPaths = [];
  this.clearSelectedCoordinates();
  state.feature.changed();
};

(TxRectMode as any).onClick = function (state: any, e: any) {
  if (CommonSelectors.noTarget(e)) return this.clickNoTarget(state, e);
  if (CommonSelectors.isActiveFeature(e))
    return this.clickActiveFeature(state, e);
  if (CommonSelectors.isInactiveFeature(e)) return this.clickInactive(state, e);
  this.stopDragging(state);
};

(TxRectMode as any).clickNoTarget = function (state: any, e: any) {
  if (state.canSelectFeatures) this.changeMode(Constants.modes.SIMPLE_SELECT);
};

(TxRectMode as any).clickInactive = function (state: any, e: any) {
  if (state.canSelectFeatures)
    this.changeMode(Constants.modes.SIMPLE_SELECT, {
      featureIds: [e.featureTarget.properties.id],
    });
};

(TxRectMode as any).onTrash = function () {
  // TODO check state.canTrash
  this.deleteFeature(this.getSelectedIds());
  // this.fireActionable();
};
